import { styled } from '@mui/material/styles';
import { Box, Card, Button } from '@mui/material';

export const StyledForm = styled('form')(({ theme }) => ({
  maxWidth: '2000px',
  width: '100%',
  margin: '0 auto',
  padding: theme.spacing(3),
  [theme.breakpoints.up('xl')]: {
    maxWidth: '2000px',
  },
}));

export const Section = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  marginBottom: theme.spacing(3),
  backgroundColor: '#ffffff',
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[1],
}));

export const LocationCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  paddingRight: theme.spacing(4), // extra space to prevent icon clipping
}));

export const HelpButton = styled(Button)(({ theme }) => ({
  position: 'fixed',
  bottom: '24px',
  right: '24px',
  backgroundColor: theme.palette.primary.main,
  color: 'white',
  borderRadius: '50%',
  width: '56px',
  height: '56px',
  minWidth: '56px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));
